import moment from 'moment'
import LoadingCircle from '../../components/LoadingCircle';
export default class SchedulerWizard {
    constructor(existingEvent=false){
        this.event=existingEvent;
        this.event_id=existingEvent ? existingEvent.id : false;
        console.log("loading exisiting event",existingEvent);
        this.modal=$("#scheduleSetupModal");
        this.avatarIcon=`<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
            <path d="M256,0c-74.439,0-135,60.561-135,135s60.561,135,135,135s135-60.561,135-135S330.439,0,256,0z" fill="#000000" data-original="#000000" class=""></path>
            <path d="M423.966,358.195C387.006,320.667,338.009,300,286,300h-60c-52.008,0-101.006,20.667-137.966,58.195    C51.255,395.539,31,444.833,31,497c0,8.284,6.716,15,15,15h420c8.284,0,15-6.716,15-15    C481,444.833,460.745,395.539,423.966,358.195z" fill="#000000" data-original="#000000" class=""></path>
        </svg>`;
        this.token=$('meta[name="csrf-token"]').attr('content');
        this.closeSetupButton=$("#closeScheduleWizardButton");
        this.defaultEventDuration=30;//default event duration is 15 minutes
        this.minDurationFromNow=5;//minimum start time is 15 minutes from current time

        this.loadingCircle = new LoadingCircle(); //loading button function
        this.loadingCircle.previousText = "SET EVENT";

        this.eventDuration=30;

        this.recurringOptionCheckbox=$("#is-kino-recurring");
        this.repeatOptionsContainer=$("#sc-recurring-options-container");
        
        this.allowGuestsCheckbox=$("#are-guests-allowed");
        this.guestsOptionsContainer=$("#sc-guests-options-container");
        this.moderatorsOptionsContainer=$("#sc-moderators-options-container");
        //tabs
        this.detailsTab=$("#schedule-details-tab");
        this.membersTab=$("#schedule-members-tab");
        this.accessTab=$("#schedule-access-tab");

        //mobile only tabs 
        this.detailsTabMobile=$('#schedule-details-tab-mobile');
        this.membersTabMobile=$('#schedule-members-tab-mobile');
        this.accessTabMobile=$('#schedule-access-tab-mobile');

        //tab connects
        this.membersTabConnect=$("#schedule-members-tab-line");
        this.accessTabConnect=$("#schedule-access-tab-line");

        //tab connects mobile
        this.connectStep1=$('#connect-line-step1');
        this.connectStep2=$('#connect-line-step2');
        
        //tab content
        this.detailsContent=$("#schedule-details-content");
        this.membersContent=$("#chedule-members-content");
        this.accessContent=$("#schedule-access-content");
        //next buttons
        this.detailsNextBtn=$("#schedule-details-next");
        this.membersNextBtn=$("#schedule-members-next");
        this.accessNextBtn=$("#schedule-finish");
        
        //back buttons
        this.detailsCancelBtn=$("#schedule-wizard-cancel");
        this.membersBackBtn=$("#schedule-members-back-button");
        this.accessBackBtn=$("#schedule-access-back-button");


        //time inputs
        this.startDateInput=$("#sch-wizard-start-date");
        this.startTimeInput=$("#sch-wizard-start-time");

        this.endDateInput=$("#sch-wizard-end-date");
        this.endTimeInput=$("#sch-wizard-end-time");


        //pickers
        this.startDatePicker;
        this.startTimePicker;

        this.endDatePicker;
        this.endTimePicker;

        //repeat options select
        this.repeatOptionsSelect=$("#sch-repeat-options");
        
        this.invitesObject=[];
        this.invitesList=$("#invites-list");
        this.inviteeInput=$("#sch-wizard-add-invitee");
        this.inviteeInputActions=$("#invitee-input-actions");


        //join time inputs
        this.moderatorsTimeInput=$("#sch-wizard-moderator-join-time");
        this.moderatorsTimePicker;
        this.membersTimeInput=$("#sch-wizard-member-join-time");
        this.membersTimePicker;
        this.guestsTimeInput=$("#sch-wizard-guests-join-time");
        this.guestsTimePicker;

        //default join ahead minutes
        this.moderatorJoinsDefault=15;
        this.memberJoinsDefault=0;
        this.guestJoinsDefault=0

        this.joinTimes={
            moderators:0,
            members:0,
            guests:0
        };

        //inputs
        this.eventTitle=$("#sch-wizard-title");
        this.eventDescription=$("#sch-wizard-description");
        this.clearChats=$("#setup-keep-chat-checkbox");
        this.onClose=()=>{};
        this.onSuccess=()=>{
            this.closeSetup();
        }

        //time containers
        this.timeContainerTop = $('#time-container-top');

        this.icsRequestCheckbox=$("#setup-ics-request-checkbox");
        this.autoComplete=[];
        this.autoCompleteDropDown=$("#email-autocomplete");
        this.autoCompleteItems=$("#email-autocomplete-items");
        this.currentAutocompleteFocus=-1;

        //warning section
        this.scheduleKinoWarning = $('#schedule-kino-warning');
    };
    
    showSetup(){
        let setup=this;
        const initialDate=this.getInitialEventDate();
        setup.eventDuration=initialDate.duration;

        console.log("INITIAL DATE",initialDate)
        $("#sch-wizard-start-time").timepicker({
            timeFormat: 'hh:mm p',
            interval: 30,
            defaultTime: initialDate.start.time,
            startTime: '00:00',
            dynamic: false,
            dropdown: true,
            scrollbar: false,
            zindex:2000,
            change: function(time) {
                setup.onStartTimeChange($("#sch-wizard-start-time").val());
                $(this).removeClass("mui--is-empty").addClass("mui--is-not-empty");
            }
        });
        this.startTimePicker=$("#sch-wizard-start-time").timepicker();
        
        $("#sch-wizard-end-time").timepicker({
            timeFormat: 'hh:mm p',
            interval: 30,
            defaultTime: initialDate.end.time,
            startTime: '00:00',
            dynamic: false,
            dropdown: true,
            scrollbar: false,
            zindex:2000,
            change: function(time) {
                setup.onEndTimeChange($("#sch-wizard-end-time").val());
                $(this).removeClass("mui--is-empty").addClass("mui--is-not-empty");
            }
        });
        this.endTimePicker=$("#sch-wizard-end-time").timepicker();
        this.startDatePicker=flatpickr("#sch-wizard-start-date", {
            minDate: initialDate.isBeforeToday ? initialDate.start.date :"today",
            defaultDate:initialDate.start.date,
            wrap: false,
            dateFormat: "Y-m-d",
            onChange:function(selectedDates, dateStr, instance){
                // console.log("Selected dates",selectedDates)
                // console.log("Dates string",dateStr)
                $("#sch-wizard-start-date").removeClass("mui--is-empty").addClass("mui--is-not-empty");
                setup.onStartDateChange(dateStr);
            },
            onReady:function(){
                $("#sch-wizard-start-date").removeClass("mui--is-empty").addClass("mui--is-not-empty");
            }
        });
        
        this.endDatePicker=flatpickr("#sch-wizard-end-date", {
            minDate: initialDate.isBeforeToday ? initialDate.start.date :"today",
            defaultDate:initialDate.end.date,
            wrap: false,
            dateFormat: "Y-m-d",
            onChange:function(selectedDates, dateStr, instance){
                // console.log("Selected dates",selectedDates)
                // console.log("Dates string",dateStr)
                $("#sch-wizard-end-date").removeClass("mui--is-empty").addClass("mui--is-not-empty");
                setup.onEndDateChange(dateStr);
            },
            onReady:function(){
                $("#sch-wizard-end-date").removeClass("mui--is-empty").addClass("mui--is-not-empty");
            }
        });
        
        if(initialDate.showEndDate){
            this.showEndDateInput();
        }
        this.fillExistingEventInputs();
        this.initKinoRecurringOption();
        this.initAllowGuestsOption();
        this.initSchedulerWizardTabs();
        this.initInviteeEmailInput();
        this.initializeJoinTimePickers(initialDate.start.date+" "+initialDate.start.time);
        this.modal.modal('show');
    };
    
    fillExistingEventInputs(){
        this.eventTitle.on('input paste',()=>{
            this.setTitleError('')
        })
        this.eventDescription.on('input paste',()=>{
            this.setDescriptionError('')
        })
        if(this.event){
            this.eventTitle.val(this.event.title).removeClass('mui--is-empty').addClass('mui--is-not-empty');
            if(this.event.summary.length){
                this.eventDescription.val(this.event.summary).removeClass('mui--is-empty').addClass('mui--is-not-empty');
            }
            //add guests
            if(this.event.guests){
                this.event.guests.forEach(email=>{
                    this.addInvitee(email).then(invitee=>{
                        this.appendInviteeToList(invitee);
                    })
                })
            }

            //add members
            if(this.event.members){
                this.event.members.forEach(email=>{
                    this.addInvitee(email,'member').then(invitee=>{
                        this.appendInviteeToList(invitee);
                    })
                })
            }

            //add moderators
            this.event.moderators.forEach(email=>{
                this.addInvitee(email,'moderator').then(invitee=>{
                    this.appendInviteeToList(invitee);
                })
            })

            if(this.event.ics_method && this.event.ics_method=="REQUEST"){
                this.icsRequestCheckbox.prop({checked:true})
            }else{
                this.icsRequestCheckbox.prop({checked:false})
            }
        }


    };

    initializeJoinTimePickers(eventStartTime){
        let setup=this;
        if(this.event){
            this.moderatorJoinsDefault=this.event.moderators_join_before;
            this.memberJoinsDefault=this.event.members_join_before;
            this.guestJoinsDefault=this.event.guest_join_before;
        }
        const eventStart=this.getMomentFromString(eventStartTime);
        const minTime=eventStart.clone().subtract(1,'hour');
        const modJoinTimeInitial=eventStart.clone().subtract(this.moderatorJoinsDefault,'minutes');
        const memberJoinTimeInitial=eventStart.clone().subtract(this.memberJoinsDefault,'minutes');
        const guestsJoinTimeInitial=eventStart.clone().subtract(this.guestJoinsDefault,'minutes')
        //moderator picker
        this.moderatorsTimeInput.timepicker({
            timeFormat: 'hh:mm p',
            interval: 15,
            defaultTime: modJoinTimeInitial.format("hh:mma"),
            startTime: minTime.format("hh:mma"),
            minTime:minTime.format("hh:mma"),
            maxTime:eventStart.format("hh:mma"),
            dynamic: false,
            dropdown: true,
            scrollbar: false,
            zindex:2000,
            change: function(time) {
                $(this).removeClass("mui--is-empty").addClass("mui--is-not-empty");
                setup.onJoinTimeChange(setup.moderatorsTimeInput.val(),'moderators',setup.moderatorsTimePicker);
            }
        });
        this.moderatorsTimePicker=this.moderatorsTimeInput.timepicker();

        //member time picker

        this.membersTimeInput.timepicker({
            timeFormat: 'hh:mm p',
            interval: 15,
            defaultTime: memberJoinTimeInitial.format("hh:mma"),
            startTime: minTime.format("hh:mma"),
            minTime:minTime.format("hh:mma"),
            maxTime:eventStart.format("hh:mma"),
            dynamic: false,
            dropdown: true,
            scrollbar: false,
            zindex:2000,
            change: function(time) {
                $(this).removeClass("mui--is-empty").addClass("mui--is-not-empty");
                setup.onJoinTimeChange(setup.membersTimeInput.val(),'members',setup.membersTimePicker);
            }
        });
        this.membersTimePicker=this.membersTimeInput.timepicker();

        //guests time picker

        this.guestsTimeInput.timepicker({
            timeFormat: 'hh:mm p',
            interval: 15,
            defaultTime: guestsJoinTimeInitial.format("hh:mma"),
            startTime: minTime.format("hh:mma"),
            minTime:minTime.format("hh:mma"),
            maxTime:eventStart.format("hh:mma"),
            dynamic: false,
            dropdown: true,
            scrollbar: false,
            zindex:2000,
            change: function(time) {
                $(this).removeClass("mui--is-empty").addClass("mui--is-not-empty");
                setup.onJoinTimeChange(setup.guestsTimeInput.val(),'guests',setup.guestsTimePicker);
            }
        });
        this.guestsTimePicker=this.guestsTimeInput.timepicker();

    };

    updateJoinTimes(eventStartTime){
        const eventStart=this.getMomentFromString(eventStartTime);
        if(eventStart=="Invalid Date"){
            return
        }
        const minTime=eventStart.clone().subtract(1,'hour');
        const modJoinTimeInitial=eventStart.clone().subtract(this.joinTimes.moderators,'minutes');
        const memberJoinTimeInitial=eventStart.clone().subtract(this.joinTimes.members,'minutes');
        const guestsJoinTimeInitial=eventStart.clone().subtract(this.joinTimes.guests,'minutes')
        console.log("Updating moderator join time",this.moderatorsTimePicker)
        if(this.moderatorsTimePicker){
            this.moderatorsTimePicker.option({
                defaultTime: modJoinTimeInitial.format("hh:mma"),
                startTime: minTime.format("hh:mma"),
                minTime:minTime.format("hh:mma"),
                maxTime:eventStart.format("hh:mma")
            },false);
            this.moderatorsTimePicker.setTime(modJoinTimeInitial.format("hh:mma"),false);
        }
        if(this.membersTimePicker){
            this.membersTimePicker.option({
                defaultTime: memberJoinTimeInitial.format("hh:mma"),
                startTime: minTime.format("hh:mma"),
                minTime:minTime.format("hh:mma"),
                maxTime:eventStart.format("hh:mma")
            },false);
            this.membersTimePicker.setTime(memberJoinTimeInitial.format("hh:mma"),false);
        }

        if(this.guestsTimePicker){
           this.guestsTimePicker.option({
                defaultTime: guestsJoinTimeInitial.format("hh:mma"),
                startTime: minTime.format("hh:mma"),
                minTime:minTime.format("hh:mma"),
                maxTime:eventStart.format("hh:mma"),
            },false);
            this.guestsTimePicker.setTime(guestsJoinTimeInitial.format("hh:mma"),false);
        }
    };

    onJoinTimeChange(time,role,picker){
        console.log(`Join time change event ${role} ${time}`,picker)
        const eventStart=this.getMomentFromString(this.startDateInput.val()+ " " +this.startTimeInput.val());
        const minTime=eventStart.clone().subtract(1,'hour');
        let joinTime=this.getMomentFromString(minTime.format("YYYY-MM-DD")+" "+time);
        const timeOnly=moment(time,"hh:mm A");
        if(minTime.format("YYYY-MM-DD")==eventStart.format("YYYY-MM-DD")){
            if(joinTime.isBefore(minTime,'minute')){
                picker.setTime(minTime.format("hh:mma"),true);
                this.joinTimes[role]=60;
            }else if(joinTime.isAfter(eventStart,'minute')){
                picker.setTime(eventStart.format("hh:mma"),true);
                this.joinTimes[role]=0;
            }else{
                this.joinTimes[role]=eventStart.diff(joinTime,'minutes');
            }
        }else{
            //midnight situation
            // console.log("moderator join hours",timeOnly.get('hours'))
            if(timeOnly.get('hours')<=1){
                joinTime=this.getMomentFromString(eventStart.format("YYYY-MM-DD")+" "+time);
            }
            console.log("Join time is ",joinTime.format("YYYY-MM-DD hh:mm A"));
            if(joinTime.isBefore(minTime,'minute')){
                picker.setTime(minTime.format("hh:mma"),true);
                this.joinTimes[role]=60;
            }else if(joinTime.isAfter(eventStart,'minute')){
                picker.setTime(eventStart.format("hh:mma"),true);
                this.joinTimes[role]=0;
            }else{
                this.joinTimes[role]=eventStart.diff(joinTime,'minutes');
            }
        }
    }

    addInvitee(email,role="none"){
        return new Promise((resolve,reject)=>{
            const exists=this.invitesObject.find(invitee=>invitee.email==email);
            if(exists){
                reject("Invitee already added")
                return
            }

            const invitee={
                email:email,
                role:role
            };
            if(this.invitesObject){
                this.hideEmptyInvites();
            }
            this.invitesObject.push(invitee);
            this.storeAutocompleteEmail(email);
            resolve(invitee);

        });
    };

    storeAutocompleteEmail(email){
        let emails=this.getStoredEmails();
        if(!emails.includes(email)){
            emails.push(email);
            localStorage.setItem('autocomplete-e',JSON.stringify(emails));
        }
        this.updateAutocompleteEmails();
    };

    updateAutocompleteEmails(){
        this.autoComplete=this.getStoredEmails();
    };

    getStoredEmails(){
        let emails=[];
        let rawEmails=localStorage.getItem('autocomplete-e');
        if(rawEmails){
            emails=JSON.parse(rawEmails);
        }
        return emails;
    };
    appendInviteeToList(invitee){
        const item=$("<li/>",{
            class:"mui-list-item"
        });
        const avatar=$("<div/>",{
            class: "mui-avatar",
            html: this.avatarIcon
        });
        const emailLabel=$("<label/>",{
            class: "mui-font-weight-500",
            html: invitee.email
        });
        const roleLabel=$("<span/>",{
            class: "mui--text-caption mui-invite-role",
            html: invitee.role == "none" ? "guest" : invitee.role
        })

        const removeBtn=$("<button/>",{
            class:"mui-action",
            html: `<i class="fa fa-times" aria-hidden="true"></i>`,
            title:"Remove"
        }).on('click',()=>{
            this.removeInvitee(invitee.email).then(()=>{
                item.remove();
            })
        });
        const moderatorBtn=$("<button/>",{
            class:`mui-action ${invitee.role == "moderator" ? 'selected' : ''}`,
            html: `<i class='fas fa-crown'></i>`,
            title:"Moderator"
        }).on('click',()=>{
            let role='moderator';
            if(moderatorBtn.hasClass('selected')){
                role='none'
            }
            this.updateInviteeRole(invitee.email,role).then(()=>{
                console.log("Invites",this.invitesObject);
                if(role=="moderator"){
                    moderatorBtn.addClass('selected')
                }else{
                    moderatorBtn.removeClass('selected')
                }
                memberBtn.removeClass("selected")
                roleLabel.html(role=="none" ? "guest" : role);
            })
        });
        const memberBtn=$("<button/>",{
            class:`mui-action ${invitee.role == "member" ? 'selected' : ''}`,
            html: this.avatarIcon,
            title:"Member"
        }).on('click',()=>{
            let role='member';
            if(memberBtn.hasClass('selected')){
                role='none'
            }
            this.updateInviteeRole(invitee.email,role).then(()=>{
                console.log("Invites",this.invitesObject);
                if(role=="member"){
                    memberBtn.addClass('selected')
                }else{
                    memberBtn.removeClass('selected')
                }
                moderatorBtn.removeClass("selected")
                roleLabel.html(role=="none" ? "guest" : role);
            })
        });

        const title=$("<div/>",{
            class:"mui-item-title",
            html:[emailLabel,roleLabel]
        });
        const actions=$("<div/>",{
            class:"mui-item-actions",
            html:[memberBtn,moderatorBtn,removeBtn]
        });

        item.html([avatar,title,actions]);


        this.invitesList.prepend(item);
    };

    removeInvitee(email){
        return new Promise((resolve,reject)=>{
            this.invitesObject=this.invitesObject.filter(invitee=>invitee.email != email);
            console.log("Invites array",this.invitesObject);
            if(!this.invitesObject.length){
                this.showEmptyInvites();
            }
            resolve();
        });
    };

    updateInviteeRole(email,role){
        return new Promise((resolve,reject)=>{
            const invitee=this.invitesObject.find(invitee=>invitee.email == email);
            if(invitee){
                invitee.role=role;
            } 
            
            resolve();
        })
    };

    showEmptyInvites(){
        this.invitesList.html(`<li class="mui-list-item invites-empty-placeholder">
            <div class="mui-empty-invites">
                <img src="/images/email/inviteEmail.png" alt="">
            </div>
        </li>`);
    };

    hideEmptyInvites(){
        this.invitesList.find('.invites-empty-placeholder').remove();
    };

    addInviteeifInputNotEmpty(){
        return new Promise((resolve,rejet)=>{
            let item = this.inviteeInput.val()
            if(!item.length){
                resolve()
                return;
            } 
            
            if(!this.validateEmail(item)){
                this.setInviteeEmailError("Invalid email address")
                resolve();
                return
            } 
            this.addInvitee(item).then(invitee=>{
                this.inviteeInput.val("");
                this.inviteeInput.trigger("input");
                this.appendInviteeToList(invitee);
                resolve()
            }).catch(err=>{
                console.error(err)
                this.setInviteeEmailError(err)
                resolve()
            })
        });
       
    };



    showAutoComplete(){
        this.autoCompleteDropDown.removeClass('d-none');
    };
    hideAutoComplete(){
        this.autoCompleteDropDown.addClass('d-none');
    }
    autoCompleteShown(){
        return !this.autoCompleteDropDown.hasClass('d-none');
    }

    makeAutocompleteItemActive(list){
        if (!list) return false;
        this.removeActive(list);
        let currentFocus=this.currentAutocompleteFocus;
        if (currentFocus >= list.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = (list.length - 1);
        list[currentFocus].classList.add("active");
        this.currentAutocompleteFocus=currentFocus;
        // console.log("making active item",list[currentFocus]);
        this.autoCompleteDropDown.attr('selected-email',list[currentFocus].getAttribute('email'));
    };

    removeActive(list){
        for (var i = 0; i < list.length; i++) {
            list[i].classList.remove("active");
          }
    }

    autoCompleteFocusUp(){
        var items = document.getElementById('email-autocomplete-items');
        if (items) items = items.getElementsByTagName("div");
        this.currentAutocompleteFocus--;
        this.makeAutocompleteItemActive(items);
    }

    autoCompleteFocusDown(){
        var items = document.getElementById('email-autocomplete-items');
        if (items) items = items.getElementsByTagName("div");
        this.currentAutocompleteFocus++;
        this.makeAutocompleteItemActive(items);
    }

    filterAutoComplete(text){
        if(text==""){
            this.hideAutoComplete();
            return
        }
        // console.log("Autocomplete emails",this.autoComplete)
        const emailMatches=[];
        const addedEmails=this.invitesObject.map(i=>i.email);
        for (let index = 0; index < this.autoComplete.length; index++) {
            const email = this.autoComplete[index];
            if(this.match(email,text) && !addedEmails.includes(email)){
                emailMatches.push(email);
            }
        }

        if(emailMatches.length && !this.autoComplete.includes(text)){
            this.autoCompleteDrawItems(emailMatches)
            if(!this.autoCompleteShown()){
                this.showAutoComplete()
            }
        }else{
            this.hideAutoComplete();
        }
    }

    addEmailFromAutocomplete(){
        const selectedEmail=this.autoCompleteDropDown.attr('selected-email');
        console.log("adding autocomplete email",selectedEmail)
        if(selectedEmail.length && this.validateEmail(selectedEmail)){
                this.addInvitee(selectedEmail).then(invitee=>{
                    console.log("Invite added",invitee)
                    this.inviteeInput.val("");
                    this.inviteeInput.trigger("input");
                    this.appendInviteeToList(invitee);
                }).catch(err=>{
                    console.error(err)
                    this.setInviteeEmailError(err)
                })
                this.inviteeInput.trigger("focus")
        }
        this.autoCompleteDropDown.attr('selected-email','');
        this.currentAutocompleteFocus=-1;
        this.autoCompleteItems.find('div').removeClass('active');
        this.inviteeInput.trigger('input');
    };

    autoCompleteDrawItems(items){
        this.autoCompleteItems.html('');
        this.autoCompleteDropDown.attr('selected-email','');
        this.currentAutocompleteFocus=-1;
        this.autoCompleteItems.off('click');
        this.autoCompleteItems.on('click',(e)=>{
            e.preventDefault();
            e.stopPropagation()
        })
        items.forEach(item=>{
            const dropdownItem=$("<div/>",{
                class:"autocomplete-item",
                html:item,
                email:item
            }).on('click',(e)=>{
                console.log("Item clicked")
                e.stopPropagation()
                e.preventDefault()
                this.addInvitee(item).then(invitee=>{
                    console.log("Invite added",invitee)
                    this.inviteeInput.val("");
                    this.inviteeInput.trigger("input");
                    this.appendInviteeToList(invitee);
                }).catch(err=>{
                    console.error(err)
                    this.setInviteeEmailError(err)
                })
                this.inviteeInput.trigger("focus")
            });
            this.autoCompleteItems.append(dropdownItem);
        });
    };

    match(str1,str2){
        return str1.match(str2);
    }
    initInviteeEmailInput(){
        if(this.invitesObject.length==0){
            this.showEmptyInvites();
        }
        this.updateAutocompleteEmails();
        const actionAdd=$("<button/>",{
            class:"mui-action d-none",
            html:`<i class="fa fa-check" aria-hidden="true"></i>`,
            title:"Add Invitee"
        }).on('click',()=>{
                let item = this.inviteeInput.val()
                if(!this.validateEmail(item)){
                    this.setInviteeEmailError("Invalid email address")
                    return false
                } 
                if(!item.length) return false;
                this.addInvitee(item).then(invitee=>{
                    this.inviteeInput.val("");
                    this.inviteeInput.trigger("input");
                    this.appendInviteeToList(invitee);
                }).catch(err=>{
                    console.error(err)
                    this.setInviteeEmailError(err)
                })
            this.inviteeInput.trigger("focus")
        });
        const actionClear=$("<button/>",{
            class:"mui-action d-none",
            html:`<i class="fa fa-times" aria-hidden="true"></i>`,
            title:"Clear"
        }).on('click',()=>{
            this.inviteeInput.val("");
            this.inviteeInput.trigger("change");
            this.inviteeInput.trigger("focus")
        });

        this.inviteeInputActions.html([actionAdd,actionClear])
        this.inviteeInput.on('keypress keydown', e => {
            let KeyID = e.keyCode;
            // console.log("Key id",KeyID)
            if(KeyID == 13 || KeyID == 32 || KeyID == 44 || KeyID==9) {
                e.preventDefault()
                if(this.autoCompleteShown() && this.currentAutocompleteFocus > -1 && KeyID!=44 && KeyID!=9){
                    this.addEmailFromAutocomplete();
                    return
                }else if(this.autoCompleteShown() && KeyID==9){
                    this.autoCompleteFocusDown();
                    return;
                }
                let item = this.inviteeInput.val()
                if(!this.validateEmail(item)){
                    this.setInviteeEmailError("Invalid email address")
                    return false
                } 
                if(!item.length) return false;
                this.addInvitee(item).then(invitee=>{
                    this.inviteeInput.val("");
                    this.inviteeInput.trigger("input");
                    this.appendInviteeToList(invitee);
                }).catch(err=>{
                    console.error(err)
                    this.setInviteeEmailError(err)
                })
            }else if(KeyID == 40){
                e.preventDefault()
                this.autoCompleteFocusDown();
            }else if(KeyID == 38){
                e.preventDefault()
                this.autoCompleteFocusUp();
            }else{
                this.setInviteeEmailError("")
            }
        }).on('focus', e => {
            
        }).on('blur',e=>{
            setTimeout(() => {
                this.hideAutoComplete();
            }, 200);
        }).on('input paste',(e)=>{
            // console.log("input event")
            let item = this.inviteeInput.val()
            this.setInviteeEmailError('')
            this.filterAutoComplete(item);
             if(!item.length){
                actionClear.addClass('d-none');
                actionAdd.addClass('d-none')
             }else{
                actionClear.removeClass('d-none');
                if(this.validateEmail(item)){
                    actionAdd.removeClass('d-none');
                }else{
                    actionAdd.addClass('d-none')
                }
             }
        });
    }
    setInviteeEmailError(error){
        $("#invitee-email-error").html(error);
    };

    validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
    setTitleError(error=''){
        $("#event-title-error").html(error);
    }

    setTimeError(error=''){
        $("#event-time-error").html(error);
    }
    setRecurringError(error=''){
        $("#recurring-option-error").html(error);
    }
    setGeneralError(error=''){
        $("#general-error").html(error);
    };
    setDescriptionError(error){
        $("#event-description-error").html(error);
    }
    getMomentFromString(timeString){
        return moment(timeString,"YYYY-MM-DD hh:mm A");
    };
    onStartDateChange(startDate){
        console.log("START DATE CHANGE",startDate);
        const eventStart=this.getMomentFromString(startDate+" "+this.startTimeInput.val());
        const eventEnd=eventStart.clone();
        eventEnd.add(this.eventDuration,'minutes');
        this.endDatePicker.setDate(eventEnd.format("YYYY-MM-DD"),true);
        this.updateRepeatOptions();
    }

    onStartTimeChange(startTime){
        console.log("START TIME CHANGE",startTime)
        const momentNow=moment().add(2,'minutes');
        const eventStart=this.getMomentFromString(this.startDateInput.val()+" "+startTime);
        if(eventStart.isBefore(momentNow,'minute') && !this.event){
            this.setTimeError(`⚠ The schedule has to be later than ${momentNow.format('MMMM Do,YYYY')} at ${momentNow.format('h:mm a')}. Please verify if your profile's timezone is correct`)
        }else{
            this.setTimeError(``)
        }
        
        const eventEnd=eventStart.clone();
        eventEnd.add(this.eventDuration,'minutes');
        if(this.endTimePicker){
            this.endTimePicker.setTime(eventEnd.format("hh:mma"),true);
        }
        if(this.endDatePicker){
            this.endDatePicker.setDate(eventEnd.format("YYYY-MM-DD"),true)
        }
        this.updateRepeatOptions();
        this.updateJoinTimes(this.startDateInput.val()+" "+startTime)

    }

    onEndDateChange(endDate){
        console.log("END DATE CHANGE",endDate);
        if(endDate!=this.startDateInput.val() && !this.isEndDateShown()){
            this.showEndDateInput();
        }
        const eventStart=this.getMomentFromString(this.startDateInput.val()+" "+this.startTimeInput.val());
        const eventEnd=this.getMomentFromString(endDate+" "+this.endTimeInput.val());
        const duration=eventEnd.diff(eventStart,'minutes');
        if(duration < 5){
            // console.log("Event duration should be more than 5 minutes")
            this.setTimeError(`⚠ The end time should be at least 5 minutes after start time.`)
        }else{
            this.setTimeError(``)
        }
    }

    onEndTimeChange(endTime){
        console.log("END TIME CHANGE",endTime)
        const eventStart=this.getMomentFromString(this.startDateInput.val()+" "+this.startTimeInput.val());
        const eventEnd=this.getMomentFromString(this.endDateInput.val()+" "+endTime);
        const duration=eventEnd.diff(eventStart,'minutes');
        if(duration < 5 && duration > 0){
            // console.log("Event duration should be more than 5 minutes")
            this.setTimeError(`⚠ The end time should be at least 5 minutes after start time.`)
        }else if(duration <= 0){
            eventEnd.set('date',eventStart.get('date')+1)
            this.setTimeError(``)
        }else{
            this.setTimeError(``)
        }
        // if(this.endTimePicker){
        //     this.endTimePicker.setTime(eventEnd.format("hh:mma"),true);
        // }
        if(this.endDatePicker){
            this.endDatePicker.setDate(eventEnd.format("YYYY-MM-DD"),true)
        }
    }


    validateScheduleStart(){

    };


    updateRepeatOptions(){
        console.log("Start Date Update repeat options ",this.startDateInput.val()+" "+this.startTimeInput.val());
        const eventStart=this.getMomentFromString(this.startDateInput.val()+" "+this.startTimeInput.val());
        if(eventStart=="Invalid Date"){
            console.log("Invalid start date")
            return 
        }
        const WeekDay=eventStart.format('dddd');
        let weekOfMonth=this.weekOfMonth(eventStart);
        const endOfMonth=eventStart.clone().endOf('month');
        const offset = endOfMonth.diff(eventStart, 'days');
        if(offset < 7){
            weekOfMonth="l";//last week of month
        }
        const weeksofmonth={
            1:"first",
            2:"second",
            3:"third",
            4:"fourth",
            5:"fifth",
            "l":"last"
        };


        console.log("Day of Week",WeekDay);
        console.log(`Week of month ${weekOfMonth} ${WeekDay}`)
        // console.log("RECURRING SELECTED IS".this.selectedRecurring)
        const options=[
            `<option value="daily" ${this.selectedRecurring=="daily" ? 'selected' : ''} >Daily</option>`,
            `<option value="weekly" ${this.selectedRecurring=="weekly" ? 'selected' : ''} >Weekly on ${WeekDay}</option>`,
            `<option value="monthly" ${this.selectedRecurring=="monthly" ? 'selected' : ''} >Monthly on the ${weeksofmonth[weekOfMonth]} ${WeekDay}</option>`,
            `<option value="annually" ${this.selectedRecurring=="annually" ? 'selected' : ''} >Annually on ${eventStart.format("MMMM D")}</option>`,
            `<option value="weekday" ${this.selectedRecurring=="weekday" ? 'selected' : ''}>Every weekday (Monday to Friday)</option>`
        ];

        this.repeatOptionsSelect.html(options);
        this.repeatOptionsSelect.on('change',()=>{
            this.selectedRecurring=this.repeatOptionsSelect.val();
            this.setRecurringError('');
        })
    };

    weekOfMonth (momentDate) {
        // const firstDayOfMonth = momentDate.clone().startOf('month');
        // const firstDayOfWeek = firstDayOfMonth.clone().startOf('week');
        // console.log("First day of month",firstDayOfMonth.format("YYYY-MM-DD"))
        // console.log("First day of week",firstDayOfWeek.format("YYYY-MM-DD"))
        // const offset = firstDayOfMonth.diff(firstDayOfWeek, 'days');
        // console.log("Days offset",offset)
        return Math.ceil((momentDate.get('date')) / 7);
      }

    getInitialEventDate(){
        let momentStart;
        let momentEnd;
        if(!this.event){
            momentStart=moment();
            momentStart.add(this.minDurationFromNow,'minutes');
            momentStart.set('minute',this.roundMinutesUp(momentStart.get('minutes')));
            momentEnd=momentStart.clone();
            momentEnd.add(this.defaultEventDuration,'minutes');

        }else{
            momentStart=this.getMomentFromString(this.event.starts)
            momentEnd=this.getMomentFromString(this.event.ends)
        }

        console.log("CURRENT TIME MOMENT",momentStart);
        return {
            start:{
                date:momentStart.format("YYYY-MM-DD"),
                time:momentStart.format("hh:mma")
            },
            end:{
                date:momentEnd.format("YYYY-MM-DD"),
                time:momentEnd.format("hh:mma")
            },
            duration:momentEnd.diff(momentStart,'minutes'),
            isBeforeToday: momentStart.isBefore(moment()),
            showEndDate: momentStart.get('date') != momentEnd.get('date')
        };
        // console.log("Minutes rouned up",this.roundMinutesUp(momentStart.get('minutes')));
    }

    roundMinutesUp(minutes,precision=15){
        const min=parseInt(minutes);
        if(isNaN(min)){
            return minutes;
        } 

        const roundedMinutes=Math.ceil(min/precision) * precision;
        return roundedMinutes;

    };


    isEndDateShown(){
        const endDateRow=$("#end-date-row");
        return !endDateRow.hasClass("collapsed");
    };


    showEndDateInput(){
        let setup = this;
        const endTimeInput=$("#end-time-input-container");
        const endTimeBottomRow=$("#end-time-container-bottom");
        const endDateRow=$("#end-date-row");
        $("#start-date-label").html("Start date")
        endTimeInput.appendTo(endTimeBottomRow);
        endDateRow.removeClass("collapsed");
        // setup.timeContainerTop.removeClass('col-sm-6').addClass('col-sm-12')
        setup.timeContainerTop.children().first().addClass('col-sm-12');
    };
    hideEndDateInput(){
        let setup = this;
        const endTimeInput=$("#end-time-input-container");
        // const endTimeBottomRow=$("#end-time-container-bottom");
        const endTimeTopRow=$("#end-time-container-top");
        $("#start-date-label").html("Event date")
        const endDateRow=$("#end-date-row");
        endTimeInput.appendTo(endTimeTopRow);
        endDateRow.addClass("collapsed");
        // setup.timeContainerTop.removeClass('col-sm-12').addClass('col-sm-6')
        setup.timeContainerTop.children().first().removeClass('col-sm-12');
    };


    initKinoRecurringOption(){
        this.selectedRecurring="daily";
        if(this.event){
            if(this.event.recurring){
                this.recurringOptionCheckbox.val(1)
                this.selectedRecurring=this.event.recurring.toLowerCase();
            }else{
                this.recurringOptionCheckbox.val(0)
            }

            if(this.event.keep_chats){
                this.clearChats.prop({checked:true});
                this.clearChats.trigger('change')
            }else{
                this.clearChats.prop({checked:false});
                this.clearChats.trigger('change')
            }
        }
        if(this.recurringOptionCheckbox.val()==1){
            $("#recurring-kino-option").addClass("active");
            $("#one-time-kino-option").removeClass("active");
            this.repeatOptionsContainer.removeClass('collapsed')
        }else{
            $("#recurring-kino-option").removeClass("active");
            $("#one-time-kino-option").addClass("active");
            this.repeatOptionsContainer.addClass('collapsed')
        }
        $("#recurring-kino-option").on('click',()=>{
            $("#recurring-kino-option").addClass("active");
            $("#one-time-kino-option").removeClass("active");
            this.recurringOptionCheckbox.val(1)
            this.repeatOptionsContainer.removeClass('collapsed')
            this.setTimeError('');
        })
        $("#one-time-kino-option").on('click',()=>{
            $("#recurring-kino-option").removeClass("active");
            $("#one-time-kino-option").addClass("active");
            this.recurringOptionCheckbox.val(0)
            this.repeatOptionsContainer.addClass('collapsed')
        })

        this.updateRepeatOptions();

    };

    initAllowGuestsOption(){
        if(this.event){
            if(this.event.allow_guests){
                this.allowGuestsCheckbox.val(1);
            }else{
                this.allowGuestsCheckbox.val(0);
            }
        }
        if(this.allowGuestsCheckbox.val()==1){
            $("#allow-guests-kino-option").addClass("active");
            $("#disallow-guests-kino-option").removeClass("active");
            this.guestsOptionsContainer.removeClass('collapsed')
            this.moderatorsOptionsContainer.removeClass('collapsed');

        }else if(this.allowGuestsCheckbox.val()==0){
            $("#allow-guests-kino-option").removeClass("active");
            $("#disallow-guests-kino-option").addClass("active");
            this.guestsOptionsContainer.addClass('collapsed')
            this.moderatorsOptionsContainer.removeClass('collapsed');
        }else{
            $("#allow-guests-kino-option").removeClass("active");
            $("#disallow-guests-kino-option").removeClass("active");
            this.guestsOptionsContainer.addClass('collapsed')
            this.moderatorsOptionsContainer.addClass('collapsed');
        }
        $("#allow-guests-kino-option").on('click',()=>{
            $("#allow-guests-kino-option").addClass("active");
            $("#disallow-guests-kino-option").removeClass("active");
            this.allowGuestsCheckbox.val(1)
            this.guestsOptionsContainer.removeClass('collapsed')
            this.moderatorsOptionsContainer.removeClass('collapsed');
            this.hideWarning();
        })
        $("#disallow-guests-kino-option").on('click',()=>{
            $("#allow-guests-kino-option").removeClass("active");
            $("#disallow-guests-kino-option").addClass("active");
            this.allowGuestsCheckbox.val(0)
            this.guestsOptionsContainer.addClass('collapsed')
            this.moderatorsOptionsContainer.removeClass('collapsed');
            this.guestToMemberWarning();
        })

    };


    initSchedulerWizardTabs(){
        let w=this;
        this.detailsNextBtn.on('click',this.showMembersTab.bind(w))
        this.detailsCancelBtn.on('click',this.closeSetup.bind(w));
        this.membersBackBtn.on('click',this.showDetailsTab.bind(w));
        this.membersNextBtn.on('click',this.showAccessTab.bind(w));

        this.accessBackBtn.on('click',this.showMembersTab.bind(w));
        this.accessNextBtn.on('click',this.createSchedule.bind(w));
        this.closeSetupButton.on('click',this.closeSetup.bind(w))

        this.detailsTab.on('click',this.showDetailsTab.bind(w));
        this.membersTab.on('click',this.showMembersTab.bind(w));
        this.accessTab.on('click',this.showAccessTab.bind(w));

    };

    closeSetup(){
        this.modal.modal('hide');
        this.destroySetup();
        this.onClose();
    };

    showDetailsTab(){
        if(this.detailsContent.hasClass("active")){return}
        this.makeTabActive('details');
        this.makeDetailsActive();
    };

    showMembersTab(){
        if(this.membersContent.hasClass("active")){return}
        this.validateDetailTab().then((data)=>{
            console.log("Validation data",data)
            this.makeTabActive('members')
            this.makeInviteActive();
        })
    };

    async showAccessTab(){
        if(this.accessContent.hasClass("active")){return}
        await this.addInviteeifInputNotEmpty();
        this.validateDetailTab().then((data)=>{
            this.validateInvitesTab().then(data=>{
                console.log("Validation data",data)
                this.makeTabActive("access");
                this.makeAccessActive();
            })
        }).catch(err =>{
            this.makeTabActive('details')
            this.makeDetailsActive();
        })
    }

    makeTabActive(tabName){
        $("#schedule-wizard").find('.wizard-content-tab').removeClass('active');
        $(`#schedule-${tabName}-content`).addClass('active');
        if(tabName=="details"){
            this.detailsTab.addClass('active');
            this.membersTab.removeClass('active');
            this.accessTab.removeClass('active');
            this.makeDetailsActive();

            //remove connect lines
            this.membersTabConnect.removeClass("active");
            this.accessTabConnect.removeClass("active");
        }else if(tabName=="members"){
            this.detailsTab.addClass('active');
            this.membersTab.addClass('active');
            this.accessTab.removeClass('active');
            this.makeInviteActive();
            //add connect lines
            this.membersTabConnect.addClass("active");
            this.accessTabConnect.removeClass("active");
        }else if(tabName=="access"){
            this.detailsTab.addClass('active');
            this.membersTab.addClass('active');
            this.accessTab.addClass('active');
            this.makeAccessActive();
            //add connect lines
            this.membersTabConnect.addClass("active");
            this.accessTabConnect.addClass("active");
        }
    };

    validateDetailTab(){
        return new Promise((resolve,reject)=>{
            const eventData={};

            //validate details page
            let detailsFailed=false;
            //title
            const title=this.eventTitle.val();
            if(!title.length){
                this.setTitleError('⚠ Please enter event name.')
                detailsFailed=true;
            }
            eventData.title=title;

            const description=this.eventDescription.val();
            eventData.description=description;

            const nowTime=moment().add(2,'minutes');
            const eventStart=this.getMomentFromString(this.startDateInput.val()+" "+this.startTimeInput.val());
            const eventEnd=this.getMomentFromString(this.endDateInput.val()+" "+this.endTimeInput.val());

            eventData.start_date=eventStart.format("YYYY-MM-DD HH:mm");
            eventData.end_date=eventEnd.format("YYYY-MM-DD HH:mm");

            if(eventStart != "Invalid Date" && eventEnd!="Invalid Date"){
                const duration=eventEnd.diff(eventStart,'minutes')
                if(eventStart.isBefore(nowTime,'minute') && (this.recurringOptionCheckbox.val() == 0 || !this.event)){
                    if(this.event && eventEnd.isAfter(nowTime,'minute')){
                        //do nothing because you are editing an event which has not yet ended
                    }else{
                        this.setTimeError(`⚠ The schedule has to be later than ${nowTime.format('MMMM Do, YYYY')} at ${nowTime.format('h:mm a')}. Please verify if your profile's timezone is correct.`)
                        detailsFailed=true;
                    }
                }else if(duration < 5){
                    detailsFailed=true;
                    this.setTimeError(`⚠ The end time should be at least 5 minutes after start time.`)
                }

            }else{
                this.setTimeError("⚠ The event date is invalid.")
                detailsFailed=true;
            }

            const recurring=this.recurringOptionCheckbox.val() == 1 ? true : false;
            eventData.recurring=recurring;
            const interval=this.repeatOptionsSelect.val();

            const clearChats=this.clearChats.is(':checked');
            eventData.clear_chats=clearChats;

            if(recurring && interval){
                eventData.recurring_interval=interval;
            }else if(recurring && !interval){
                detailsFailed=true;
                this.setRecurringError("Please select a repeat option")
            }

            if(detailsFailed){
                this.showDetailsTab();
                reject();
                return
            }
            resolve(eventData)
        })
    }

    validateInvitesTab(){
        return new Promise((resolve,reject)=>{
            const eventData={
                moderators:[],
                members:[],
                guests:[],
                ics_method:"REQUEST"
            };

            if(this.invitesObject && this.invitesObject.length){
                eventData.moderators=this.invitesObject.filter(i=>i.role=="moderator").map(i=>i.email);
                eventData.members=this.invitesObject.filter(i=>i.role=="member").map(i=>i.email);
                eventData.guests=this.invitesObject.filter(i=>i.role=="none").map(i=>i.email);
            }

            if(this.icsRequestCheckbox.is(':checked')){
                eventData.ics_method="REQUEST";
            }else{
                eventData.ics_method="PUBLISH";
            }
            resolve(eventData);
        });
    };

    validateAccessTab(){
        return new Promise((resolve,reject)=>{
            const eventData={
                allow_guests: this.allowGuestsCheckbox.val()==1 ? true : false,
                moderators_join_before: this.joinTimes.moderators,
                members_join_before: this.joinTimes.members,
                guests_join_before: this.joinTimes.guests
            };
            resolve(eventData);
        });
    }

    async validateAndCollect(){
       try {
        const details = await this.validateDetailTab();
        const invites = await this.validateInvitesTab();
        const access = await this.validateAccessTab();
        return {
            ...details,
            ...invites,
            ...access
        };

       } catch (error) {
            console.log(error)
            return false;
       }
    };

    async createSchedule(){
        const setup=this;
        const data=await this.validateAndCollect();
        console.log("Event data",data)
        if(!data){
            return
        }
        setup.setGeneralError('');
        setup.disableButtonsOnSubmit();
        if(!data.allow_guests && data.guests.length > 0){
            data.members = data.members.concat(data.guests);
            data.guests = [];
        }
        const sendData={
            schedule_id: this.event_id,
            title: data.title,
            summary: data.description,
            start_date: data.start_date,
            end_date: data.end_date,
            recurring: data.recurring ? data.recurring_interval : null,
            moderators: data.moderators.join(","),
            members: data.members.join(","),
            guests: data.guests.join(","),
            allow_guests: data.allow_guests ? "on" : null,
            keep_chats: data.clear_chats,
            moderators_join_before: data.moderators_join_before,
            members_join_before: data.members_join_before,
            guest_join_before: data.guests_join_before,
            ics_method: data.ics_method
        };

        if(!data.allow_guests){
            delete sendData.allow_guests;
        }
        return await $.ajax({
            url: "/schedule/add",
            data: sendData,
            type: "POST",
            beforeSend: (xhr) => {xhr.setRequestHeader('X-CSRF-TOKEN', this.token);},
            statusCode: {
                422: function(r) {
                    if(r.responseJSON.errors.title){
                        setup.setTitleError(`⚠ ${r.responseJSON.errors.title[0]}`);
                        setup.showDetailsTab();
                    } else if(r.responseJSON.errors.start_date){
                        setup.setTimeError(`⚠ ${r.responseJSON.errors.start_date[0]}. Please verify if your profile\'s timezone is correct`);
                        setup.showDetailsTab();
                    }else if(r.responseJSON.errors.end_date){
                        setup.setTimeError(`⚠ ${r.responseJSON.errors.end_date[0]}`);
                        setup.showDetailsTab();
                    }else if(r.responseJSON.errors.summary){
                        setup.setDescriptionError(`⚠ ${r.responseJSON.errors.summary[0]}`);
                        setup.showDetailsTab();
                    }else{
                        setup.setGeneralError(`⚠ ${r.responseJSON.message}`)
                    }
                },
               // Begin card code 500
                400: function(r){
                    if(r.responseJSON.message){
                        setup.setTimeError(`⚠ ${r.responseJSON.message}`);
                        setup.showDetailsTab();
                    }

                    setup.enableModalButtons();
                },
                500: function(r){
                    if(r.responseJSON.message){
                        setup.setGeneralError(`⚠ Something went wrong`)
                    }
                    setup.enableModalButtons();
                }   
               // End card code 500
            }
        }).done((res) => {
            //  this.listSchedules();
            if(res.success===true){
            //    callback(res)
               //on success
               this.onSuccess(res);
               this.closeSetup();
            }else{
            //general message
                setup.setGeneralError(`⚠ ${res.message}`)
                setup.enableModalButtons();
            }
        });

    };

    disableSaveEventBtn(){
        this.loadingCircle.buttonShow(this.accessNextBtn);
    }

    enableSaveEventBtn(){
        this.loadingCircle.buttonHide(this.accessNextBtn);
    }

    makeDetailsActive(){
        let setup = this;
        if(!setup.detailsTabMobile.hasClass('active')){
            setup.detailsTabMobile.addClass('active')
            setup.membersTabMobile.removeClass('active');
            setup.accessTabMobile.removeClass('active');
        }
        setup.connectStep1.removeClass('active').addClass('invisible');
        setup.connectStep2.removeClass('active invisible');
    }

    makeInviteActive(){
        let setup = this;
        if(!setup.membersTabMobile.hasClass('active')){
            setup.detailsTabMobile.removeClass('active')
            setup.membersTabMobile.addClass('active');
            setup.accessTabMobile.removeClass('active');
        }
        setup.connectStep1.addClass('active').removeClass('invisible');
        setup.connectStep2.removeClass('active invisible');
    }
    
    makeAccessActive(){
        let setup = this;
        if(!setup.accessTabMobile.hasClass('active')){
            setup.detailsTabMobile.removeClass('active')
            setup.membersTabMobile.removeClass('active');
            setup.accessTabMobile.addClass('active');
        }
        setup.connectStep1.removeClass('invisible').addClass('active');
        setup.connectStep2.removeClass('active').addClass('invisible');
        if($('#disallow-guests-kino-option').hasClass('active')){
            this.guestToMemberWarning();
        }
    }

    disableButtonsOnSubmit(){
        let setup = this;
        setup.disableSaveEventBtn();
        setup.detailsTab.addClass('pe-none');
        setup.membersTab.addClass('pe-none');
        setup.accessTab.addClass('pe-none');
        $('#wizard-tabs-desktop').addClass('cursor-not-allowed');
        setup.accessBackBtn.addClass('pe-none').attr('disabled',true);
    }

    enableModalButtons(){
        let setup = this;
        setup.enableSaveEventBtn();
        setup.detailsTab.removeClass('pe-none');
        setup.membersTab.removeClass('pe-none');
        setup.accessTab.removeClass('pe-none');
        $('#wizard-tabs-desktop').removeClass('cursor-not-allowed');
        setup.accessBackBtn.removeClass('pe-none').removeAttr('disabled');
    }

    guestToMemberWarning(){
        let error = false;
        for(var i=0; i < this.invitesObject.length; i++){
            // console.log(this.invitesObject[i].role)
            if(this.invitesObject[i].role == 'none'){
                error = true;
            }
            if(error){
                this.showWarning('Some invitees were marked as guests. Those invitees will be automatically assigned members role to allow them access to the scheduled Kino.')
                break;
            }else{
                error = false;
            }
        }
        if(!error){
            this.hideWarning();
        }
    }

    showWarning(message){
        this.scheduleKinoWarning.removeClass('d-none');
        this.scheduleKinoWarning.find('.kino-warning-text p').html(message);
    }

    hideWarning(){
        this.scheduleKinoWarning.addClass('d-none');
        this.scheduleKinoWarning.find('.kino-warning-text p').html('');
    }

    destroySetup(){
        //clear inputs
        this.eventTitle.val('').addClass('mui--is-empty').removeClass('mui--is-not-empty');
        this.eventDescription.val('').addClass('mui--is-empty').removeClass('mui--is-not-empty');
        this.setTitleError('');
        this.setTimeError('');
        this.setDescriptionError('');
        this.setRecurringError('');
        this.setInviteeEmailError('')
        //recurring options
        this.recurringOptionCheckbox.val(0);
        this.repeatOptionsContainer.addClass('collapsed')
        this.clearChats.prop({checked:false});

        this.icsRequestCheckbox.prop({checked:true});
        //guests options
        this.allowGuestsCheckbox.val(1);
        this.guestsOptionsContainer.removeClass('collapsed');
        this.moderatorsOptionsContainer.removeClass('collapsed');
        //time date inputs
        this.startDatePicker && this.startDatePicker.destroy();
        this.startDateInput.val('');

        this.endDatePicker && this.endDatePicker.destroy();
        this.endDateInput.val('');

        this.startTimePicker && this.startTimePicker.destroy();
        this.startTimeInput.val('');

        this.endTimePicker && this.endTimePicker.destroy();
        this.endTimeInput.val('');

        this.moderatorsTimePicker && this.moderatorsTimePicker.destroy();
        this.moderatorsTimeInput.val('');

        this.membersTimePicker && this.membersTimePicker.destroy();
        this.membersTimeInput.val();

        this.guestsTimePicker && this.guestsTimePicker.destroy();
        this.guestsTimeInput.val('');

        //
        this.hideEndDateInput();
        this.makeTabActive('details');
        this.showEmptyInvites();
        //input events
        this.inviteeInput.val('');
        this.inviteeInput.off()
        this.closeSetupButton.off();
        this.detailsCancelBtn.off()
        this.detailsNextBtn.off()
        this.membersBackBtn.off();
        this.membersNextBtn.off();
        this.accessBackBtn.off();
        this.accessNextBtn.off();
        this.detailsTab.off();
        this.membersTab.off();
        this.accessTab.off();
        this.repeatOptionsSelect.off();
        this.setGeneralError('');
        this.enableSaveEventBtn();
        this.enableModalButtons();
        this.hideWarning();
    };
};